"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Link = forwardRef(
  ({ children, ...props }, ref) => /* @__PURE__ */ jsx("a", { ...props, ref, children })
);
Link.displayName = "Link";
export {
  Link
};
